const CrosstabDisplayTypeDetail = Object.freeze({
  NONE: 'NONE',
  COLUMNS: 'COLUMNS',
  ROWS: 'ROWS',
  ROW_GRAND_TOTAL: 'ROW_GRAND_TOTAL'
})
export default CrosstabDisplayTypeDetail
export type CrosstabDisplayTypeDetailStrings = typeof CrosstabDisplayTypeDetail[keyof typeof CrosstabDisplayTypeDetail]
// RESERVE BELOW
